import { render, staticRenderFns } from "./BuildingObjectList.vue?vue&type=template&id=11b05a9a&scoped=true"
import script from "./BuildingObjectList.vue?vue&type=script&lang=js"
export * from "./BuildingObjectList.vue?vue&type=script&lang=js"
import style0 from "./BuildingObjectList.vue?vue&type=style&index=0&id=11b05a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b05a9a",
  null
  
)

export default component.exports